<template>
  <div class="contact">
    <div class="wrapper">
      <div class="text"
        >请发送您的合作需求至<span class="blue">「betterWE星球」官方邮箱</span>
        邮件主题为：<span class="blue">姓名＋合作形式＋联系方式</span>
        在收到完整资料的7个工作日内，我们将会有专职团队<br />
        与您联系，感谢您对betterWE星球的支持与信任！</div
      >
      <div class="tips">betterWE星球官方邮箱：</div>
      <div class="email-content">
        <div class="email">{{ email }}</div>
        <div class="copy" ref="copy" :data-clipboard-text="email">复制</div>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard'
export default {
  data() {
    return {
      email: 'betterweapp@163.com'
    }
  },
  mounted() {
    this.initCopy()
  },
  methods: {
    initCopy() {
      let el = this.$refs.copy
      if (el) {
        this.clipboard = new Clipboard(el)
        this.clipboard.on('success', () => {
          this.$toast('复制成功')
        })
        this.clipboard.on('error', () => {
          this.$toast('复制失败')
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.contact {
  user-select: none;
  padding: 16px;
  min-height: 100vh;
  box-sizing: border-box;
  background: #f9f9f9;

  .wrapper {
    background: #ffffff;
    border-radius: 10px;
    padding: 16px 16px 20px;

    .text {
      margin-bottom: 11px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.8);
      line-height: 24px;

      .blue {
        color: #6236ff;
      }
    }

    .tips {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 24px;
      margin-bottom: 6px;
    }

    .email-content {
      background: #f1f1f1;
      border-radius: 6px;
      padding: 4px 16px 4px 24px;
      display: flex;
      align-items: center;

      .email {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 24px;
      }

      .copy {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 24px;
      }
    }
  }
}
</style>
